// extracted by css-extract-rspack-plugin
export default {"squareBanner":"IpmBannerBase-module__squareBanner__LXt3H"};